import { createMetaBindings } from '@gift/website-state/slices/metaSlice';
import { BasicSceneMeta } from '@gift/basic-scene-core/BasicSceneMeta';

const { createMetaUpdateAction, createMetaSelector } = createMetaBindings<BasicSceneMeta>();

export const updateCommission = createMetaUpdateAction('commission');
export const updatePrefabId = createMetaUpdateAction('prefabId');

export const selectActivePrefabId = createMetaSelector(p => p.prefabId);